const enGB = {
  navigation: {
    mydevice: "Mijn apparaat",
    mymobile: "My mobile"
  },
  photoorganiser: {
    navigation: {
      photos: "Foto's",
      favorites: "Favorieten",
      collections: "Collecties",
      events: "Evenementen",
      latestuploads: "Laatste uploads"
    },
    empty(source) {
      return "Je hebt geen foto's in " + source
    }
  },
  mymobile: {
    title: "Get your phone photos in an instant!",
    qrcode: {
      title: "Scan the QR code",
      subtitle: "(No need to install App)"
    },
    instruction: {
      title: "Let's get started!",
      step_1: "Open your camera app",
      step_2: "Scan the QR code",
      step_3: "Follow the instruction on your mobile"
    }
  },
  layout: {
    flex: "Flexibel",
    square: "Vierkant"
  },
  calender: {
    allmonths: "Alle maanden",
    allyears: "Alle jaren",
    months: {
      january: "januari",
      february: "februari",
      march: "maart",
      april: "april",
      may: "mei",
      june: "juni",
      july: "juli",
      august: "augustus",
      september: "september",
      october: "oktober",
      november: "november",
      december: "december"
    }
  },
  generic: {
    sortBy: "Sorteren op",
    selected: "Geselecteerd",
    done: "Voeg foto's toe",
    back: "Terug",
    images: "Foto's",
    selection: "Selectie",
    date: "Datum",
    name: "Naam",
    az: "Bestandsnaam A-Z",
    za: "Bestandsnaam Z-A",
    newestfirst: "Datum gesorteerd op nieuw-oud",
    oldestfirst: "Datum gesorteerd op oud-nieuw",
    photos: "Foto's",
    all: "Alle",
    yes: "Ja",
    no: "Nee",
    nodate: "Geen datum"
  },
  rangeText: {
    minMax(min, max) {
      return "Je moet tussen " + min + " en " + max + " foto's selecteren"
    },
    min(min) {
      return "Je hebt minimaal " + min + " foto's nodig om je fotoboek te maken."
    },
    max(max) {
      return "Je kunt maximaal " + max + "  foto's selecteren"
    }
  },
  addMorePhotos: "Meer foto's toevoegen",
  upload: {
    browseButton: "Foto's toevoegen",
    uploadlimit(maxSize) {
      return "Afbeeldingen moeten kleiner zijn dan " + maxSize
    },
    dragImage: "of sleep en plaats hier je bestanden.",
    errors: {
      GENERIC_ERROR: "Er is iets mis gegaan. Probeer het opnieuw of neem contact op met de klantenservice.",
      EMPTY_FILE: "Afbeeldingsreferentie verloren, voeg de afbeelding opnieuw toe",
      MAX_FILE_SIZE: "Bestand moet kleiner zijn dan {0} MB",
      UNSUPPORTED_FILE_TYPE: "Niet ondersteund bestandsformaat",
      MAX_IMAGE_RESOLUTION: "Bestand moet kleiner zijn dan {0} pixels",
      INVALID_IMAGE: "Bestand is beschadigd"
    },
    errorSummary(number) {
      return number + " bestanden konden niet geüpload worden"
    },
    errorDialog: {
      headline: "Oeps!",
      ingress: "De volgende bestanden konden niet geüpload worden:",
      filenameColumn: "Bestand",
      reasonColumn: "Reden"
    },
    uploaded: "Geüpload",
    estimating: "Geschatte tijd",
    estimatedleft: "Geschatte resterende tijd",
    ok: "OK",
    cancel: "Annuleren",
    details: "Details"
  }
}

export default enGB
